import { slug } from '@magalu/mixer-utils';
var shippingError = function shippingError(data) {
  var _data$value, _data$value$error, _data$value2, _data$value3, _data$value4, _data$value5, _data$value6;
  if (!(data == null ? void 0 : (_data$value = data.value) == null ? void 0 : _data$value.errorCode)) return null;
  var errorMessage = (_data$value$error = data == null ? void 0 : (_data$value2 = data.value) == null ? void 0 : _data$value2.error) !== null && _data$value$error !== void 0 ? _data$value$error : 'cep-invalido';
  return {
    cep: (data == null ? void 0 : (_data$value3 = data.value) == null ? void 0 : _data$value3.zipCode) || null,
    code: data == null ? void 0 : (_data$value4 = data.value) == null ? void 0 : _data$value4.errorCode,
    content_type: "produto:frete",
    deliveriesId: (data == null ? void 0 : (_data$value5 = data.value) == null ? void 0 : _data$value5.deliveriesId) || null,
    event: 'shipping_error',
    item_id: "".concat((data == null ? void 0 : (_data$value6 = data.value) == null ? void 0 : _data$value6.productId) || null, ":").concat(slug(errorMessage)).substring(0, 99)
  };
};
export default shippingError;